<template>
  <div>
    <!-- Tabs -->
    <el-tabs
      v-model="activeName"
      type="border-card"
      style="width: 100%;"
      :before-leave="beforeTabLeave"
    >
      <el-tab-pane label="课程列表" name="first">
        <div class="main">
          <!-- Right -->
          <div class="main_r">
            <!-- search -->
            <div class="search">
              <div class="search-content">
                <el-select
                  v-model="queryData.courseType"
                  placeholder="课程分类"
                >
                  <el-option label="课程分类" value="0"></el-option>
                  <el-option
                    v-for="item in aptustwoGvListCourseType"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="queryData.priorityType"
                  placeholder="优先分类"
                >
                  <el-option label="新课优先" value="1"></el-option>
                  <el-option label="人气优先" value="2"></el-option>
                </el-select>
                <el-select
                  v-model="queryData.courseDifficulty"
                  placeholder="课程难度"
                >
                  <el-option label="课程难度" value="0"></el-option>
                  <el-option
                    v-for="item in aptustwoGvListCourseDifficulty"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="queryData.courseTimeType"
                  placeholder="课程时长分类"
                >
                  <el-option label="课程时长分类" value="0"></el-option>
                  <el-option
                    v-for="item in aptustwoGvListCourseTimeType"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  >
                  </el-option>
                </el-select>
                <el-select v-model="queryData.bodyType" placeholder="部位分类">
                  <el-option label="部位分类" value=""></el-option>
                  <el-option
                    v-for="item in aptustwoGvListBodyType"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="queryData.courseAccessories"
                  placeholder="所需配件"
                >
                  <el-option label="所需配件" value=""></el-option>
                  <el-option
                    v-for="item in aptustwoGvListAccessories"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  >
                  </el-option>
                </el-select>
                <el-input
                  v-model="queryData.courseName"
                  placeholder="课程名称"
                ></el-input>
                <el-select v-model="queryData.isHome" placeholder="首页推荐">
                  <el-option label="首页推荐" value="-1"></el-option>
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
                <el-select
                  v-model="queryData.isBanner"
                  placeholder="Banner推荐"
                >
                  <el-option label="Banner推荐" value="-1"></el-option>
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
                <el-button type="primary" @click="clickQuery">查询</el-button>
                <el-button type="primary" @click="clickQueryReset" plain
                  >重置</el-button
                >
                <el-button type="primary" @click="clickdialogAdd"
                  >新增</el-button
                >
                <el-button type="success" @click="clickBatchAdd"
                  >批量新增</el-button
                >
              </div>
            </div>
            <!-- search End -->

            <!-- 列表 -->
            <div class="table-container">
              <el-table
                :data="dataList"
                class="mt15"
                :header-cell-style="{ textAlign: 'center' }"
                :cell-style="{ textAlign: 'center' }"
              >
                <el-table-column
                  prop="id"
                  label="序号"
                  width="80"
                  fixed="left"
                ></el-table-column>
                <el-table-column
                  prop="courseTypeUi"
                  label="课程分类"
                  width="150"
                ></el-table-column>
                <el-table-column
                  prop="bodyTypeUi"
                  label="部位分类"
                  width="120"
                ></el-table-column>
                <el-table-column
                  prop="courseName"
                  label="课程名称"
                  width="180"
                ></el-table-column>
                <el-table-column prop="" label="列表封面" width="100">
                  <template v-slot="scope">
                    <el-image
                      v-if="scope.row.courseIconUi"
                      style="width: 48px; height: 48px"
                      :src="scope.row.courseIconUi"
                      :preview-src-list="[scope.row.courseIconUi]"
                      fit="cover">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="详情页封面" width="110">
                  <template v-slot="scope">
                    <el-image
                      v-if="scope.row.courseIconDetailsUi"
                      style="width: 48px; height: 48px"
                      :src="scope.row.courseIconDetailsUi"
                      :preview-src-list="[scope.row.courseIconDetailsUi]"
                      fit="cover">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="Banner封面" width="110">
                  <template v-slot="scope">
                    <el-image
                      v-if="scope.row.courseIconBannerUi"
                      style="width: 48px; height: 48px"
                      :src="scope.row.courseIconBannerUi"
                      :preview-src-list="[scope.row.courseIconBannerUi]"
                      fit="cover">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="courseDifficultyUi"
                  label="课程难度"
                  width="100"
                ></el-table-column>
                <el-table-column
                  prop="courseTime"
                  label="课程时长"
                  width="100"
                >
                  <template slot-scope="props">
                    {{ props.row.courseTime }}秒
                  </template>
                </el-table-column>
                <el-table-column
                  prop="courseRest"
                  label="组之间的休息"
                  width="120"
                >
                  <template slot-scope="props">
                    {{ props.row.courseRest }}秒
                  </template>
                </el-table-column>
                <el-table-column
                  prop="courseRestMax"
                  label="动作之间的休息"
                  width="130"
                >
                  <template slot-scope="props">
                    {{ props.row.courseRestMax }}秒
                  </template>
                </el-table-column>
                <el-table-column prop="" label="预计容量" width="100">
                  <template v-slot="scope"> {{ scope.row.courseKg }}Kg </template>
                </el-table-column>
                <el-table-column
                  prop="courseKcal"
                  label="预计消耗"
                  width="100"
                >
                  <template v-slot="scope">
                    {{ scope.row.courseKcal }}Kcal
                  </template>
                </el-table-column>
                <el-table-column prop="isHome" label="首页推荐" width="100">
                  <template slot-scope="props">
                    <span v-if="props.row.isHome == 0">否</span>
                    <span v-if="props.row.isHome == 1">是</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isBanner"
                  label="Banner推荐"
                  width="110"
                >
                  <template slot-scope="props">
                    <span v-if="props.row.isBanner == 0">否</span>
                    <span v-if="props.row.isBanner == 1">是</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="创建时间"
                  width="180"
                ></el-table-column>
                <el-table-column prop="Operation" label="操作" width="150" fixed="right">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="编辑"
                      placement="top"
                      :enterable="false"
                    >
                      <el-link
                        :underline="false"
                        type="primary"
                        icon="el-icon-edit"
                        class="mr12"
                        @click="clickdialogEdit(scope.row)"
                      ></el-link>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="删除"
                      placement="top"
                      :enterable="false"
                    >
                      <el-link
                        :underline="false"
                        type="danger"
                        icon="el-icon-delete"
                        class="mr12"
                        @click="ClickDelete(scope.row)"
                      ></el-link>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="管理课程动作"
                      placement="top"
                      :enterable="false"
                    >
                      <el-link
                        :underline="false"
                        type="primary"
                        icon="el-icon-view"
                        class="mr12"
                        @click="gotoWebTwoCourseAction(scope.row)"
                      ></el-link>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <!-- 分页 -->
            <div class="mt20">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page_no"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="page_size"
                layout="prev, pager, next, sizes, jumper "
                :total="dataListnum"
              >
              </el-pagination>
            </div>
            <!-- 分页 End -->
          </div>
          <!-- Right End -->

          <!---------------------- 以下是弹框内容 ---------------------->
          <!-- 新增 -->
          <el-dialog
            title="添加课程"
            :visible.sync="dialogAdd"
            width="35%"
            class="newAdd"
            :close-on-click-modal="false"
            v-loading="uploadLoading"
          >
            <div class="addUser_body">
              <el-form ref="userMsg" :model="addData" label-width="150px">
                <el-form-item label="课程分类" :required="true">
                  <el-select
                    v-model="addData.courseType"
                    multiple
                    placeholder="课程分类"
                  >
                    <el-option
                      v-for="item in aptustwoGvListCourseType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="部位分类" :required="true">
                  <el-select
                    v-model="addData.bodyType"
                    multiple
                    placeholder="部位分类"
                  >
                    <el-option
                      v-for="item in aptustwoGvListBodyType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="课程名称" :required="true">
                  <el-input
                    v-model="addData.courseName"
                    placeholder="请输入课程名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="列表封面" :required="true">
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleAddCourseIconUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true"
                  >
                    <img
                      v-if="addData.courseIconUi || addData.courseIcon"
                      :src="
                        addData.courseIconUi || getImageUrl(addData.courseIcon)
                      "
                      class="cover-image"
                    />
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="详情页封面" :required="true">
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleAddCourseIconDetailsUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true"
                  >
                    <img
                      v-if="
                        addData.courseIconDetailsUi || addData.courseIconDetails
                      "
                      :src="
                        addData.courseIconDetailsUi ||
                          getImageUrl(addData.courseIconDetails)
                      "
                      class="cover-image"
                    />
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="Banner封面" :required="true">
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleAddCourseIconBannerUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true"
                  >
                    <img
                      v-if="
                        addData.courseIconBannerUi || addData.courseIconBanner
                      "
                      :src="
                        addData.courseIconBannerUi ||
                          getImageUrl(addData.courseIconBanner)
                      "
                      class="cover-image"
                    />
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="课程难度" :required="true">
                  <el-select
                    v-model="addData.courseDifficulty"
                    placeholder="课程难度"
                  >
                    <el-option
                      v-for="item in aptustwoGvListCourseDifficulty"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="组之间的休息时长" :required="true">
                  <el-input
                    v-model="addData.courseRest"
                    placeholder="请输入组之间的休息时长"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >秒</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="动作之间的休息时长" :required="true">
                  <el-input
                    v-model="addData.courseRestMax"
                    placeholder="请输入动作之间的休息时长"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >秒</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <!--                  <el-form-item label="课程时长" :required=true>
                    <el-input v-model="addData.courseTime" placeholder="请输入课程时长"></el-input>
                  </el-form-item>
                  <el-form-item label="预计容量" :required=true>
                    <el-input v-model="addData.courseKg" placeholder="请输入预计容量"></el-input>
                  </el-form-item>
                  <el-form-item label="预计消耗" :required=true>
                    <el-input v-model="addData.courseKcal" placeholder="请输入预计消耗"></el-input>
                  </el-form-item> -->
                <el-form-item label="训练肌群" :required="true">
                  <el-select
                    v-model="addData.courseMuscleRoup"
                    multiple
                    placeholder="训练肌群"
                  >
                    <el-option
                      v-for="item in aptustwoGvListMuscleRoup"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所需配件" :required="true">
                  <el-select
                    v-model="addData.courseAccessories"
                    multiple
                    placeholder="所需配件"
                  >
                    <el-option
                      v-for="item in aptustwoGvListAccessories"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="首页推荐" :required="true">
                  <el-select v-model="addData.isHome" placeholder="首页推荐">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Banner推荐" :required="true">
                  <el-select
                    v-model="addData.isBanner"
                    placeholder="Banner推荐"
                  >
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="推荐标题" :required="true">
                  <el-input
                    v-model="addData.bannerTitle"
                    placeholder="请输入推荐标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="推荐描述" :required="true">
                  <el-input
                    type="textarea"
                    v-model="addData.bannerDescription"
                    placeholder="请输入推荐描述"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="CourseDatabaseInsert()"
                >确 认</el-button
              >
              <el-button @click="dialogAdd = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 新增 End -->

          <!-- 编辑课程 -->
          <el-dialog
            title="编辑课程"
            :visible.sync="dialogEdit"
            width="35%"
            class="newAdd"
            :close-on-click-modal="false"
            v-loading="uploadLoading"
          >
            <div class="addUser_body">
              <el-form ref="userMsg" :model="editData" label-width="150px">
                <el-form-item label="课程分类" :required="true">
                  <el-select
                    v-model="editData.courseType"
                    multiple
                    placeholder="课程分类"
                  >
                    <el-option
                      v-for="item in aptustwoGvListCourseType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="部位分类" :required="true">
                  <el-select
                    v-model="editData.bodyType"
                    multiple
                    placeholder="部位分类"
                  >
                    <el-option
                      v-for="item in aptustwoGvListBodyType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="课程名称" :required="true">
                  <el-input
                    v-model="editData.courseName"
                    placeholder="请输入课程名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="列表封面" :required="true">
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleEditCourseIconUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true"
                  >
                    <img
                      v-if="editData.courseIconUi || editData.courseIcon"
                      :src="
                        editData.courseIconUi ||
                          getImageUrl(editData.courseIcon)
                      "
                      class="cover-image"
                    />
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="详情页封面" :required="true">
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleEditCourseIconDetailsUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true"
                  >
                    <img
                      v-if="
                        editData.courseIconDetailsUi ||
                          editData.courseIconDetails
                      "
                      :src="
                        editData.courseIconDetailsUi ||
                          getImageUrl(editData.courseIconDetails)
                      "
                      class="cover-image"
                    />
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="Banner封面" :required="true">
                  <el-upload
                    class="cover-uploader"
                    :action="''"
                    :http-request="handleEditCourseIconBannerUpload"
                    :show-file-list="false"
                    :before-upload="beforeImageUpload"
                    :auto-upload="true"
                  >
                    <img
                      v-if="
                        editData.courseIconBannerUi || editData.courseIconBanner
                      "
                      :src="
                        editData.courseIconBannerUi ||
                          getImageUrl(editData.courseIconBanner)
                      "
                      class="cover-image"
                    />
                    <i v-else class="el-icon-plus cover-uploader-icon"></i>
                  </el-upload>
                  <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
                </el-form-item>
                <el-form-item label="课程难度" :required="true">
                  <el-select
                    v-model="editData.courseDifficulty"
                    placeholder="课程难度"
                  >
                    <el-option
                      v-for="item in aptustwoGvListCourseDifficulty"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="组之间的休息时长" :required="true">
                  <el-input
                    v-model="editData.courseRest"
                    placeholder="请输入组之间的休息时长"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >秒</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="动作之间的休息时长" :required="true">
                  <el-input
                    v-model="editData.courseRestMax"
                    placeholder="请输入动作之间的休息时长"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >秒</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="课程时长" :required="true">
                  <el-input
                    v-model="editData.courseTime"
                    placeholder="请输入课程时长"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >秒</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="预计容量" :required="true">
                  <el-input
                    v-model="editData.courseKg"
                    placeholder="请输入预计容量"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >Kg</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="预计消耗" :required="true">
                  <el-input
                    v-model="editData.courseKcal"
                    placeholder="请输入预计消耗"
                  >
                    <template slot="append">
                      <span
                        style="width: 100px; display: inline-block;text-align: center;"
                        >Kcal</span
                      >
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="训练肌群" :required="true">
                  <el-select
                    v-model="editData.courseMuscleRoup"
                    multiple
                    placeholder="训练肌群"
                  >
                    <el-option
                      v-for="item in aptustwoGvListMuscleRoup"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所需配件" :required="true">
                  <el-select
                    v-model="editData.courseAccessories"
                    multiple
                    placeholder="所需配件"
                  >
                    <el-option
                      v-for="item in aptustwoGvListAccessories"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="首页推荐" :required="true">
                  <el-select v-model="editData.isHome" placeholder="首页推荐">
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Banner推荐" :required="true">
                  <el-select
                    v-model="editData.isBanner"
                    placeholder="Banner推荐"
                  >
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="推荐标题" :required="true">
                  <el-input
                    v-model="editData.bannerTitle"
                    placeholder="请输入推荐标题"
                  ></el-input>
                </el-form-item>
                <el-form-item label="推荐描述" :required="true">
                  <el-input
                    type="textarea"
                    v-model="editData.bannerDescription"
                    placeholder="请输入推荐描述"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="CourseDatabaseUpdate()"
                >确 认</el-button
              >
              <el-button @click="dialogEdit = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 编辑课程 End -->

          <!-- 删除 -->
          <el-dialog
            title="操作确认"
            :visible.sync="dialogDel"
            width="20%"
            class="confirmDel"
          >
            <div class="confirmMsg">确定删除？</div>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="CourseDatabaseDelete"
                >确 定</el-button
              >
              <el-button @click="dialogDel = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 删除 End -->

          <!-- 批量新增弹窗 -->
          <el-dialog
            title="批量新增课程"
            :visible.sync="dialogBatchAdd"
            fullscreen
            class="batch-dialog"
            :close-on-click-modal="false"
          >
            <div class="batch-add-container">
              <div class="batch-toolbar">
                <el-button
                  type="primary"
                  @click="addBatchRow"
                  icon="el-icon-plus"
                  >添加一行</el-button
                >
                <el-button
                  type="warning"
                  @click="clearBatchData"
                  icon="el-icon-delete"
                  >清空</el-button
                >
                <span class="batch-tip"
                  >提示：表格支持直接编辑，必填字段不能为空</span
                >
              </div>

              <el-table
                :data="batchData"
                border
                stripe
                class="batch-table"
                height="calc(100vh - 220px)"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  width="60"
                  align="center"
                ></el-table-column>

                <el-table-column label="课程分类" width="150">
                  <template slot="header">
                    <span class="required-field">课程分类</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.courseType"
                      multiple
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in aptustwoGvListCourseType"
                        :key="item.gv"
                        :label="item.name"
                        :value="item.gv"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="部位分类" width="150">
                  <template slot="header">
                    <span class="required-field">部位分类</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.bodyType"
                      multiple
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in aptustwoGvListBodyType"
                        :key="item.gv"
                        :label="item.name"
                        :value="item.gv"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="课程名称" width="150">
                  <template slot="header">
                    <span class="required-field">课程名称</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.courseName"
                      placeholder="必填"
                      size="small"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="列表封面" width="180">
                  <template slot="header">
                    <span class="required-field">列表封面</span>
                  </template>
                  <template slot-scope="scope">
                    <el-upload
                      class="batch-uploader"
                      :action="''"
                      :http-request="
                        options =>
                          handleBatchIconUpload(
                            options,
                            scope.$index,
                            'courseIcon'
                          )
                      "
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true"
                    >
                      <img
                        v-if="scope.row.courseIconUi || scope.row.courseIcon"
                        :src="
                          scope.row.courseIconUi ||
                            getImageUrl(scope.row.courseIcon)
                        "
                        class="batch-preview-image"
                      />
                      <el-button
                        v-else
                        size="mini"
                        type="primary"
                        icon="el-icon-upload"
                        >上传</el-button
                      >
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column label="详情页封面" width="180">
                  <template slot="header">
                    <span class="required-field">详情页封面</span>
                  </template>
                  <template slot-scope="scope">
                    <el-upload
                      class="batch-uploader"
                      :action="''"
                      :http-request="
                        options =>
                          handleBatchIconUpload(
                            options,
                            scope.$index,
                            'courseIconDetails'
                          )
                      "
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true"
                    >
                      <img
                        v-if="
                          scope.row.courseIconDetailsUi ||
                            scope.row.courseIconDetails
                        "
                        :src="
                          scope.row.courseIconDetailsUi ||
                            getImageUrl(scope.row.courseIconDetails)
                        "
                        class="batch-preview-image"
                      />
                      <el-button
                        v-else
                        size="mini"
                        type="primary"
                        icon="el-icon-upload"
                        >上传</el-button
                      >
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column label="Banner封面" width="180">
                  <template slot="header">
                    <span class="required-field">Banner封面</span>
                  </template>
                  <template slot-scope="scope">
                    <el-upload
                      class="batch-uploader"
                      :action="''"
                      :http-request="
                        options =>
                          handleBatchIconUpload(
                            options,
                            scope.$index,
                            'courseIconBanner'
                          )
                      "
                      :show-file-list="false"
                      :before-upload="beforeImageUpload"
                      :auto-upload="true"
                    >
                      <img
                        v-if="
                          scope.row.courseIconBannerUi ||
                            scope.row.courseIconBanner
                        "
                        :src="
                          scope.row.courseIconBannerUi ||
                            getImageUrl(scope.row.courseIconBanner)
                        "
                        class="batch-preview-image"
                      />
                      <el-button
                        v-else
                        size="mini"
                        type="primary"
                        icon="el-icon-upload"
                        >上传</el-button
                      >
                    </el-upload>
                  </template>
                </el-table-column>

                <el-table-column label="课程难度" width="120">
                  <template slot="header">
                    <span class="required-field">课程难度</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.courseDifficulty"
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in aptustwoGvListCourseDifficulty"
                        :key="item.gv"
                        :label="item.name"
                        :value="item.gv"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="组之间的休息(秒)" width="130">
                  <template slot="header">
                    <span class="required-field">组之间的休息(秒)</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.courseRest"
                      placeholder="秒"
                      size="small"
                      type="number"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="动作之间的休息(秒)" width="150">
                  <template slot="header">
                    <span class="required-field">动作之间的休息(秒)</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.courseRestMax"
                      placeholder="秒"
                      size="small"
                      type="number"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="训练肌群" width="150">
                  <template slot="header">
                    <span class="required-field">训练肌群</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.courseMuscleRoup"
                      multiple
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in aptustwoGvListMuscleRoup"
                        :key="item.gv"
                        :label="item.name"
                        :value="item.gv"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="所需配件" width="150">
                  <template slot="header">
                    <span class="required-field">所需配件</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.courseAccessories"
                      multiple
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in aptustwoGvListAccessories"
                        :key="item.gv"
                        :label="item.name"
                        :value="item.gv"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="首页推荐" width="120">
                  <template slot="header">
                    <span class="required-field">首页推荐</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.isHome"
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="Banner推荐" width="120">
                  <template slot="header">
                    <span class="required-field">Banner推荐</span>
                  </template>
                  <template slot-scope="scope">
                    <el-select
                      v-model="scope.row.isBanner"
                      placeholder="选择"
                      size="small"
                      style="width: 100%"
                    >
                      <el-option label="否" value="0"></el-option>
                      <el-option label="是" value="1"></el-option>
                    </el-select>
                  </template>
                </el-table-column>

                <el-table-column label="推荐标题" width="150">
                  <template slot="header">
                    <span class="required-field">推荐标题</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.bannerTitle"
                      placeholder="必填"
                      size="small"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="推荐描述" width="180">
                  <template slot="header">
                    <span class="required-field">推荐描述</span>
                  </template>
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.bannerDescription"
                      placeholder="推荐描述"
                      size="small"
                      type="textarea"
                      :rows="2"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column
                  label="操作"
                  width="80"
                  fixed="right"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="danger"
                      icon="el-icon-delete"
                      size="mini"
                      circle
                      @click="deleteBatchRow(scope.$index)"
                    ></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button
                type="success"
                @click="saveBatchData"
                :loading="batchLoading"
                icon="el-icon-check"
                >保存全部</el-button
              >
              <el-button @click="dialogBatchAdd = false">取 消</el-button>
            </div>
          </el-dialog>
          <!-- 批量新增弹窗 End -->
        </div>
      </el-tab-pane>

      <!-- 管理课程动作 start -->
      <el-tab-pane :label="TabSecondTitle" name="second">
        <WebTwoCourseAction
          ref="SubVuesecond"
          v-on:triggerFunc="BackToFirst"
        ></WebTwoCourseAction>
      </el-tab-pane>
      <!-- 管理课程动作 end -->
    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Qs from "qs";
import UploadExcel from "../components/UploadExcel.vue";
import WebTwoCourseAction from "@/componentsSubVue/WebTwoCourseAction.vue";
Vue.use(VueAxios, axios);

export default {
  components: {
    UploadExcel,
    WebTwoCourseAction
  },
  data() {
    return {
      activeName: "first",
      formLabelWidth: "120px",
      aptustwoGvListCourseType: [],
      aptustwoGvListCourseDifficulty: [],
      aptustwoGvListCourseTimeType: [],
      aptustwoGvListBodyType: [],
      aptustwoGvListMuscleRoup: [],
      aptustwoGvListAccessories: [],
      queryData: {
        courseType: "0",
        priorityType: "1",
        courseDifficulty: "0",
        courseTimeType: "0",
        bodyType: "",
        courseAccessories: "",
        courseName: "",
        isHome: "-1",
        isBanner: "-1"
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      // 新增
      dialogAdd: false,
      addData: {
        courseType: [],
        bodyType: [],
        courseName: "",
        courseIcon: "",
        courseIconUi: "",
        courseIconDetails: "",
        courseIconDetailsUi: "",
        courseIconBanner: "",
        courseIconBannerUi: "",
        courseDifficulty: "",
        courseTime: "1",
        courseRest: "30",
        courseRestMax: "60",
        courseKg: "1",
        courseKcal: "1",
        courseMuscleRoup: [],
        courseAccessories: [],
        isHome: "",
        isBanner: "",
        bannerTitle: "",
        bannerDescription: ""
      },
      uploadAction: Vue.prototype.global.Url_Base + "Upload/file",
      uploadLoading: false,
      // 编辑
      dialogEdit: false,
      editData: {
        id: "",
        courseType: [],
        bodyType: [],
        courseName: "",
        courseIcon: "",
        courseIconUi: "",
        courseIconDetails: "",
        courseIconDetailsUi: "",
        courseIconBanner: "",
        courseIconBannerUi: "",
        courseDifficulty: "",
        courseTime: "",
        courseRest: "",
        courseRestMax: "",
        courseKg: "",
        courseKcal: "",
        courseMuscleRoup: [],
        courseAccessories: [],
        isHome: "",
        isBanner: "",
        bannerTitle: "",
        bannerDescription: ""
      },
      // 删除
      deleteForm: {
        id: ""
      },
      dialogDel: false,
      allowChangeTab: false,
      TabSecondTitle: "管理课程动作",
      // 批量新增
      dialogBatchAdd: false,
      batchData: [],
      batchLoading: false
    };
  },
  mounted() {
    this.aptustwoGvListCourseType = JSON.parse(
      localStorage.getItem("aptustwoGvListCourseType")
    );
    this.aptustwoGvListCourseDifficulty = JSON.parse(
      localStorage.getItem("aptustwoGvListCourseDifficulty")
    );
    this.aptustwoGvListCourseTimeType = JSON.parse(
      localStorage.getItem("aptustwoGvListCourseTimeType")
    );
    this.aptustwoGvListBodyType = JSON.parse(
      localStorage.getItem("aptustwoGvListBodyType")
    );
    this.aptustwoGvListMuscleRoup = JSON.parse(
      localStorage.getItem("aptustwoGvListMuscleRoup")
    );
    this.aptustwoGvListAccessories = JSON.parse(
      localStorage.getItem("aptustwoGvListAccessories")
    );
    this.CourseDatabaseList();
    this.CourseDatabaseNum();
  },
  methods: {
    BackToFirst(val) {
      this.activeName = "first";
      this.TabSecondTitle = "管理课程动作";
      this.CourseDatabaseList();
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== "first") {
        this.$message.warning("禁止点击");
        return false;
      }
      this.allowChangeTab = false;
      return true;
    },
    clickQuery() {
      this.page_no = 1;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
    },
    clickQueryReset() {
      this.queryData.courseType = "0";
      this.queryData.priorityType = "1";
      this.queryData.courseDifficulty = "0";
      this.queryData.courseTimeType = "0";
      this.queryData.bodyType = "";
      this.queryData.courseAccessories = "";
      this.queryData.courseName = "";
      this.queryData.isHome = "-1";
      this.queryData.isBanner = "-1";
      this.clickQuery();
    },
    clickdialogAdd() {
      this.dialogAdd = true;
      this.addData.courseType = [];
      this.addData.bodyType = [];
      this.addData.courseName = "";
      this.addData.courseIcon = "";
      this.addData.courseIconUi = "";
      this.addData.courseIconDetails = "";
      this.addData.courseIconDetailsUi = "";
      this.addData.courseIconBanner = "";
      this.addData.courseIconBannerUi = "";
      this.addData.courseDifficulty = "";
      this.addData.courseTime = "1";
      this.addData.courseRest = "30";
      this.addData.courseRestMax = "60";
      this.addData.courseKg = "1";
      this.addData.courseKcal = "1";
      this.addData.courseMuscleRoup = [];
      this.addData.courseAccessories = [];
      this.addData.isHome = "";
      this.addData.isBanner = "";
      this.addData.bannerTitle = "";
      this.addData.bannerDescription = "";
    },
    clickdialogEdit(row) {
      this.dialogEdit = true;
      this.editData.id = row.id;
      this.editData.courseType = Vue.prototype.ConvertStringToArray(
        row.courseType
      );
      this.editData.bodyType = Vue.prototype.ConvertStringToArray(row.bodyType);
      this.editData.courseName = row.courseName;
      this.editData.courseIcon = row.courseIcon;
      this.editData.courseIconUi = row.courseIconUi;
      this.editData.courseIconDetails = row.courseIconDetails;
      this.editData.courseIconDetailsUi = row.courseIconDetailsUi;
      this.editData.courseIconBanner = row.courseIconBanner;
      this.editData.courseIconBannerUi = row.courseIconBannerUi;
      this.editData.courseDifficulty = row.courseDifficulty.toString();
      this.editData.courseTime = row.courseTime;
      this.editData.courseRest = row.courseRest;
      this.editData.courseRestMax = row.courseRestMax;
      this.editData.courseKg = row.courseKg;
      this.editData.courseKcal = row.courseKcal;
      this.editData.courseMuscleRoup = Vue.prototype.ConvertStringToArray(
        row.courseMuscleRoup
      );
      this.editData.courseAccessories = Vue.prototype.ConvertStringToArray(
        row.courseAccessories
      );
      this.editData.isHome = row.isHome.toString();
      this.editData.isBanner = row.isBanner.toString();
      this.editData.bannerTitle = row.bannerTitle;
      this.editData.bannerDescription = row.bannerDescription;
    },
    ClickDelete(row) {
      this.dialogDel = true;
      this.deleteForm.id = row.id;
    },
    gotoWebTwoCourseAction(row) {
      this.allowChangeTab = true;
      this.TabSecondTitle = "管理课程动作-【" + row.courseName + "】";
      this.activeName = "second";
      this.$refs.SubVuesecond.LoadData(row);
    },
    changeUploadExcel(response) {
      console.log(response);
      Vue.prototype.FunRemindOnlyError(response);
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data);
        this.CourseDatabaseList();
        this.CourseDatabaseNum();
      }
    },
    CourseDatabaseList: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = that.queryData.courseType;
      data.priorityType = that.queryData.priorityType;
      data.courseDifficulty = that.queryData.courseDifficulty;
      data.courseTimeType = that.queryData.courseTimeType;
      data.bodyType = that.queryData.bodyType;
      data.courseAccessories = that.queryData.courseAccessories;
      data.courseName = that.queryData.courseName;
      data.isHome = that.queryData.isHome;
      data.isBanner = that.queryData.isBanner;
      data.pageNo = that.page_no;
      data.pageSize = that.page_size;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseList, Qs.stringify(data))
        .then(function(response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CourseDatabaseNum: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = that.queryData.courseType;
      data.priorityType = that.queryData.priorityType;
      data.courseDifficulty = that.queryData.courseDifficulty;
      data.courseTimeType = that.queryData.courseTimeType;
      data.bodyType = that.queryData.bodyType;
      data.courseAccessories = that.queryData.courseAccessories;
      data.courseName = that.queryData.courseName;
      data.isHome = that.queryData.isHome;
      data.isBanner = that.queryData.isBanner;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseNum, Qs.stringify(data))
        .then(function(response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CourseDatabaseInsert: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = Vue.prototype.ConvertArrayToString(
        that.addData.courseType
      );
      data.bodyType = Vue.prototype.ConvertArrayToString(that.addData.bodyType);
      data.courseName = that.addData.courseName;
      data.courseIcon = that.addData.courseIcon;
      data.courseIconDetails = that.addData.courseIconDetails;
      data.courseIconBanner = that.addData.courseIconBanner;
      data.courseDifficulty = that.addData.courseDifficulty;
      data.courseTime = that.addData.courseTime;
      data.courseRest = that.addData.courseRest;
      data.courseRestMax = that.addData.courseRestMax;
      data.courseKg = that.addData.courseKg;
      data.courseKcal = that.addData.courseKcal;
      data.courseMuscleRoup = Vue.prototype.ConvertArrayToString(
        that.addData.courseMuscleRoup
      );
      data.courseAccessories = Vue.prototype.ConvertArrayToString(
        that.addData.courseAccessories
      );
      data.isHome = that.addData.isHome;
      data.isBanner = that.addData.isBanner;
      data.bannerTitle = that.addData.bannerTitle;
      data.bannerDescription = that.addData.bannerDescription;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseInsert, Qs.stringify(data))
        .then(function(response) {
          Vue.prototype.FunRemindOnlyError(response.data);
          if (response.data.code === 1) {
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
            that.dialogAdd = false;
          }
        })
        .catch(function(error) {
          console.log(error);
          that.dialogAdd = false;
        });
    },
    CourseDatabaseUpdate: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.id = that.editData.id;
      data.courseType = Vue.prototype.ConvertArrayToString(
        that.editData.courseType
      );
      data.bodyType = Vue.prototype.ConvertArrayToString(
        that.editData.bodyType
      );
      data.courseName = that.editData.courseName;
      data.courseIcon = that.editData.courseIcon;
      data.courseIconDetails = that.editData.courseIconDetails;
      data.courseIconBanner = that.editData.courseIconBanner;
      data.courseDifficulty = that.editData.courseDifficulty;
      data.courseTime = that.editData.courseTime;
      data.courseRest = that.editData.courseRest;
      data.courseRestMax = that.editData.courseRestMax;
      data.courseKg = that.editData.courseKg;
      data.courseKcal = that.editData.courseKcal;
      data.courseMuscleRoup = Vue.prototype.ConvertArrayToString(
        that.editData.courseMuscleRoup
      );
      data.courseAccessories = Vue.prototype.ConvertArrayToString(
        that.editData.courseAccessories
      );
      data.isHome = that.editData.isHome;
      data.isBanner = that.editData.isBanner;
      data.bannerTitle = that.editData.bannerTitle;
      data.bannerDescription = that.editData.bannerDescription;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseUpdate, Qs.stringify(data))
        .then(function(response) {
          that.dialogEdit = false;
          Vue.prototype.FunRemindOnlyError(response.data);
          if (response.data.code === 1) {
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
          }
        })
        .catch(function(error) {
          console.log(error);
          that.dialogEdit = false;
        });
    },
    CourseDatabaseDelete: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.id = that.deleteForm.id;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseDelete, Qs.stringify(data))
        .then(function(response) {
          Vue.prototype.FunRemindOnlyError(response.data);
          if (response.data.code === 1) {
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
          }
          that.dialogDel = false;
        })
        .catch(function(error) {
          console.log(error);
          that.dialogDel = false;
        });
    },
    // 图片上传前校验
    beforeImageUpload(file) {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },
    // 新增-列表封面上传
    handleAddCourseIconUpload(options) {
      this.handleFileUpload(options, "add", "courseIcon", "images/course/");
    },
    // 新增-详情页封面上传
    handleAddCourseIconDetailsUpload(options) {
      this.handleFileUpload(
        options,
        "add",
        "courseIconDetails",
        "images/course/"
      );
    },
    // 新增-Banner封面上传
    handleAddCourseIconBannerUpload(options) {
      this.handleFileUpload(
        options,
        "add",
        "courseIconBanner",
        "images/course/"
      );
    },
    // 编辑-列表封面上传
    handleEditCourseIconUpload(options) {
      this.handleFileUpload(options, "edit", "courseIcon", "images/course/");
    },
    // 编辑-详情页封面上传
    handleEditCourseIconDetailsUpload(options) {
      this.handleFileUpload(
        options,
        "edit",
        "courseIconDetails",
        "images/course/"
      );
    },
    // 编辑-Banner封面上传
    handleEditCourseIconBannerUpload(options) {
      this.handleFileUpload(
        options,
        "edit",
        "courseIconBanner",
        "images/course/"
      );
    },
    // 通用文件上传处理
    handleFileUpload(options, type, field, category) {
      var that = this;
      var formData = new FormData();
      var data = Vue.prototype.FunGetBaseSignData();

      // 显示 loading
      that.uploadLoading = true;

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data);

      // 签名后再添加type参数（type不参与签名计算）
      data.type = "ajax";

      // 添加文件
      formData.append("file", options.file);

      // 添加其他参数
      formData.append("tempUuid", data.tempUuid);
      formData.append("timestamp", data.timestamp);
      formData.append("type", data.type);
      formData.append("sign", data.sign);
      formData.append("category", category);

      // 使用axios手动上传
      axios
        .post(that.uploadAction, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          that.uploadLoading = false;
          if (response.data.code === 1) {
            // 使用返回的absoluteUrl，无需手动拼接URL
            const targetData = type === "add" ? that.addData : that.editData;
            const uiField = field + "Ui";
            // 使用$set确保响应式更新
            that.$set(targetData, field, response.data.data.relativeUrl);
            that.$set(targetData, uiField, response.data.data.absoluteUrl);
            that.$message.success("上传成功");
            options.onSuccess(response.data);
          } else {
            that.$message.error("上传失败：" + response.data.message);
            options.onError(response.data);
          }
        })
        .catch(function(error) {
          that.uploadLoading = false;
          console.log(error);
          that.$message.error("上传失败！");
          options.onError(error);
        });
    },
    // 图片URL处理
    getImageUrl(url) {
      if (!url) return "";
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url;
    },
    // 批量新增 - 打开弹窗
    clickBatchAdd() {
      this.dialogBatchAdd = true;
      // 默认添加一行
      if (this.batchData.length === 0) {
        this.addBatchRow();
      }
    },
    // 批量新增 - 添加一行
    addBatchRow() {
      this.batchData.push({
        courseType: [],
        bodyType: [],
        courseName: "",
        courseIcon: "",
        courseIconUi: "",
        courseIconDetails: "",
        courseIconDetailsUi: "",
        courseIconBanner: "",
        courseIconBannerUi: "",
        courseDifficulty: "",
        courseTime: "1",
        courseRest: "30",
        courseRestMax: "60",
        courseKg: "1",
        courseKcal: "1",
        courseMuscleRoup: [],
        courseAccessories: [],
        isHome: "0",
        isBanner: "0",
        bannerTitle: "",
        bannerDescription: ""
      });
    },
    // 批量新增 - 删除一行
    deleteBatchRow(index) {
      this.$confirm("确定删除该行数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.batchData.splice(index, 1);
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },
    // 批量新增 - 清空
    clearBatchData() {
      this.$confirm("确定清空所有数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.batchData = [];
          this.$message.success("清空成功");
        })
        .catch(() => {});
    },
    // 批量新增 - 图片上传
    handleBatchIconUpload(options, index, field) {
      var that = this;
      var formData = new FormData();
      var data = Vue.prototype.FunGetBaseSignData();

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data);

      // 签名后再添加type参数（type不参与签名计算）
      data.type = "ajax";

      // 添加文件
      formData.append("file", options.file);

      // 添加其他参数
      formData.append("tempUuid", data.tempUuid);
      formData.append("timestamp", data.timestamp);
      formData.append("type", data.type);
      formData.append("sign", data.sign);
      formData.append("category", "images/course/");

      // 使用axios手动上传
      axios
        .post(that.uploadAction, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.data.code === 1) {
            const uiField = field + "Ui";
            // 使用$set确保响应式更新
            that.$set(
              that.batchData[index],
              field,
              response.data.data.relativeUrl
            );
            that.$set(
              that.batchData[index],
              uiField,
              response.data.data.absoluteUrl
            );
            that.$message.success("上传成功");
            options.onSuccess(response.data);
          } else {
            that.$message.error("上传失败：" + response.data.message);
            options.onError(response.data);
          }
        })
        .catch(function(error) {
          console.log(error);
          that.$message.error("上传失败！");
          options.onError(error);
        });
    },
    // 批量新增 - 保存数据
    saveBatchData() {
      var that = this;

      // 校验必填字段
      for (let i = 0; i < that.batchData.length; i++) {
        const row = that.batchData[i];
        if (!row.courseType || row.courseType.length === 0) {
          that.$message.error(`第${i + 1}行：课程分类不能为空`);
          return;
        }
        if (!row.bodyType || row.bodyType.length === 0) {
          that.$message.error(`第${i + 1}行：部位分类不能为空`);
          return;
        }
        if (!row.courseName) {
          that.$message.error(`第${i + 1}行：课程名称不能为空`);
          return;
        }
        if (!row.courseIcon) {
          that.$message.error(`第${i + 1}行：列表封面不能为空`);
          return;
        }
        if (!row.courseIconDetails) {
          that.$message.error(`第${i + 1}行：详情页封面不能为空`);
          return;
        }
        if (!row.courseIconBanner) {
          that.$message.error(`第${i + 1}行：Banner封面不能为空`);
          return;
        }
        if (!row.courseDifficulty) {
          that.$message.error(`第${i + 1}行：课程难度不能为空`);
          return;
        }
        if (!row.courseMuscleRoup || row.courseMuscleRoup.length === 0) {
          that.$message.error(`第${i + 1}行：训练肌群不能为空`);
          return;
        }
        if (!row.courseAccessories || row.courseAccessories.length === 0) {
          that.$message.error(`第${i + 1}行：所需配件不能为空`);
          return;
        }
        if (!row.isHome) {
          that.$message.error(`第${i + 1}行：首页推荐不能为空`);
          return;
        }
        if (!row.isBanner) {
          that.$message.error(`第${i + 1}行：Banner推荐不能为空`);
          return;
        }
        if (!row.bannerTitle) {
          that.$message.error(`第${i + 1}行：推荐标题不能为空`);
          return;
        }
        if (!row.bannerDescription) {
          that.$message.error(`第${i + 1}行：推荐描述不能为空`);
          return;
        }
      }

      // 构造批量新增数据
      const courseList = that.batchData.map(row => ({
        courseType: Vue.prototype.ConvertArrayToString(row.courseType),
        bodyType: Vue.prototype.ConvertArrayToString(row.bodyType),
        courseName: row.courseName,
        courseIcon: row.courseIcon,
        courseIconDetails: row.courseIconDetails,
        courseIconBanner: row.courseIconBanner,
        courseDifficulty: row.courseDifficulty,
        courseTime: row.courseTime,
        courseRest: row.courseRest,
        courseRestMax: row.courseRestMax,
        courseKg: row.courseKg,
        courseKcal: row.courseKcal,
        courseMuscleRoup: Vue.prototype.ConvertArrayToString(
          row.courseMuscleRoup
        ),
        courseAccessories: Vue.prototype.ConvertArrayToString(
          row.courseAccessories
        ),
        isHome: row.isHome,
        isBanner: row.isBanner,
        bannerTitle: row.bannerTitle,
        bannerDescription: row.bannerDescription
      }));
      var data = {
        tempUuid: localStorage.getItem("tempUuid"),
        courseList: courseList
      };
      that.batchLoading = true;

      axios
        .post(
          Vue.prototype.global.Url_Base + "CourseDatabase/batchInsert",
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          that.batchLoading = false;
          Vue.prototype.FunRemindOnlyError(response.data);
          if (response.data.code === 1) {
            that.$message.success("批量新增成功");
            that.batchData = [];
            that.dialogBatchAdd = false;
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
          }
        })
        .catch(function(error) {
          that.batchLoading = false;
          console.log(error);
          that.$message.error("批量新增失败！");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.search {
  margin-top: 15px;

  .search-content {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    align-items: center;
  }

  .el-input {
    width: 150px;
  }

  .el-select {
    width: 150px;
  }
}

@media (max-width: 1440px) {
  .search {
    margin-top: 15px;

    .search-content {
      gap: 10px;
    }

    .el-input {
      width: 120px;
    }

    .el-select {
      width: 130px;
    }
  }
}

.el-table thead {
  color: #666;
}

.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao {
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2) {
      margin-top: -10px;
    }
  }
}

.position {
  overflow: hidden;
  height: 332px;
  background: #f7f7f7;
}

/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th,
.el-table tr {
  background: #eff3ff;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.newAdd /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body {
  padding: 0 46px 0 30px;
  max-height: 60vh;
  overflow-y: auto;
}

// 表格横向滚动容器
.table-container {
  width: 100%;
  overflow-x: auto;
}

/deep/ .el-button--primary {
  color: #fff;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}

// 圆角处理
/deep/ thead tr th:nth-child(1) {
  border-radius: 10px 0 0 0;
}
/deep/ thead tr th:nth-last-child(2) {
  border-radius: 0 10px 0 0;
}

// 上传组件样式
.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409eff;
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

// 批量新增样式
.batch-dialog {
  /deep/ .el-dialog__header {
    padding: 15px 20px;
    background: #f6f6fa;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    height: calc(100vh - 130px);
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px;
    text-align: center;
    border-top: 1px solid #f2f2f2;
  }
}

.batch-add-container {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.batch-toolbar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  .batch-tip {
    color: #909399;
    font-size: 14px;
    margin-left: 20px;
  }
}

.batch-table {
  flex: 1;

  /deep/ .el-table__body-wrapper {
    overflow-x: auto;
  }

  /deep/ .el-input__inner {
    padding: 5px 10px;
  }

  /deep/ .el-textarea__inner {
    padding: 5px 10px;
    min-height: 50px !important;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

// 批量上传组件样式
.batch-uploader {
  /deep/ .el-upload {
    display: block;
    text-align: center;
  }
}

.batch-preview-image {
  width: 60px;
  height: 60px;
  display: block;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 auto;
}

// 必填字段标记
.required-field {
  &::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>

<style scoped>
::v-deep .el-tabs__content {
  padding: 5px;
}
</style>
